if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.currentVariant = this.querySelector('.product-variant-id');
    }

    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;
    quantityRequestId = 0;

    connectedCallback() {
      if (!this.input) return;
      this.quantityForm = this.querySelector('.product-form__quantity');
      if (!this.quantityForm) return;
      this.setQuantityBoundries();
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        // Una compra rápida y la ficha pueden compartir el origen, pero no la instancia.
        if (event.data.instanceSectionId && event.data.instanceSectionId !== this.dataset.section) return;
        const sectionId = this.dataset.originalSection || this.dataset.section;
        if (event.data.sectionId !== sectionId) return;
        this.quantityRequestId += 1;
        this.updateQuantityRules(event.data.sectionId, event.data.html);
        this.setQuantityBoundries();
      });
    }

    disconnectedCallback() {
      this.quantityRequestId += 1;
      this.cartUpdateUnsubscriber?.();
      this.variantChangeUnsubscriber?.();
      this.cartUpdateUnsubscriber = undefined;
      this.variantChangeUnsubscriber = undefined;
    }

    setQuantityBoundries() {
      const formQuantity = this.querySelector('.product_quantity_input');
      const data = formQuantity?.dataset.min ? formQuantity.dataset : this.input.dataset;
      const cartQuantity = Math.max(0, parseInt(data.cartQuantity, 10) || 0);
      const ruleMin = Math.max(1, parseInt(data.min, 10) || 1);
      const step = Math.max(1, parseInt(data.step || this.input.step, 10) || 1);
      const customMin = Math.max(1, parseInt(this.input.closest('quantity-input-v2')?.dataset.customMin, 10) || 1);
      const parsedMax = parseInt(data.max, 10);
      let max = Number.isFinite(parsedMax) ? Math.max(0, parsedMax - cartQuantity) : null;
      let min = Math.max(customMin, cartQuantity >= ruleMin ? Math.min(ruleMin, step) : ruleMin);

      // Si el carrito ya alcanzó el máximo, no queda una cantidad válida para agregar.
      if (max !== null && max < min) {
        min = 0;
        max = 0;
      }
      this.input.min = min;
      this.input.step = step;
      if (max === null) this.input.removeAttribute('max');
      else this.input.max = max;

      // Conservamos la elección al cambiar variante; solo ajustamos lo que incumple sus reglas.
      let quantity = Number(this.input.value);
      if (!Number.isFinite(quantity) || this.input.value === '') quantity = min;
      quantity = min + Math.max(0, Math.ceil((quantity - min) / step)) * step;
      if (max !== null) quantity = Math.min(quantity, min + Math.floor((max - min) / step) * step);
      this.input.value = quantity;
      if (formQuantity) formQuantity.value = quantity;
      const quantityDisplay = this.quantityForm.querySelector('.quantity-number');
      if (quantityDisplay) quantityDisplay.textContent = quantity;
      publish(PUB_SUB_EVENTS.quantityUpdate, { sectionId: this.dataset.section });
    }

    fetchQuantityRules() {
      if (!this.currentVariant?.value) return;
      const requestedVariantId = this.currentVariant.value;
      const requestId = ++this.quantityRequestId;
      const loadingOverlay = this.querySelector('.quantity__rules-cart .loading-overlay');
      loadingOverlay?.classList.remove('hidden');
      const url = new URL(this.dataset.url, window.location.origin);
      url.searchParams.set('variant', requestedVariantId);
      url.searchParams.set('section_id', this.dataset.section);
      fetch(url.toString())
        .then((response) => {
          if (!response.ok) throw new Error('No se pudieron actualizar las reglas de cantidad.');
          return response.text();
        })
        .then((responseText) => {
          if (requestId !== this.quantityRequestId || this.currentVariant.value !== requestedVariantId) return;
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.updateQuantityRules(this.dataset.section, html);
          this.setQuantityBoundries();
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          if (requestId === this.quantityRequestId) loadingOverlay?.classList.add('hidden');
        });
    }

    updateQuantityRules(sectionId, html) {
      if (!html) return;
      const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
      const formUpdated = html.getElementById(`product-form-${sectionId}`);
      const formQuantity = this.querySelector('.product_quantity_input');
      const updatedFormQuantity = formUpdated?.querySelector('.product_quantity_input');
      if (formQuantity && updatedFormQuantity) {
        for (const attribute of ['data-cart-quantity', 'data-min', 'data-max', 'data-step']) {
          const value = updatedFormQuantity.getAttribute(attribute);
          if (value === null) formQuantity.removeAttribute(attribute);
          else formQuantity.setAttribute(attribute, value);
        }
      }
      if (!quantityFormUpdated) return;
      for (const selector of ['.quantity__input', '.quantity__rules', '.quantity__label']) {
        const current = this.quantityForm.querySelector(selector);
        const updated = quantityFormUpdated.querySelector(selector);
        if (!current || !updated) continue;
        if (selector === '.quantity__input') {
          for (const attribute of ['data-cart-quantity', 'data-min', 'data-max', 'step']) {
            const value = updated.getAttribute(attribute);
            if (value === null) current.removeAttribute(attribute);
            else current.setAttribute(attribute, value);
          }
        } else {
          current.innerHTML = updated.innerHTML;
        }
      }
    }
  });
}
